import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getSupplierSuggestion = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getComponent = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_COMPONENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getComposition = async (data) => {
  try {
    // return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_COMPOSITION}${id}`
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_COMPOSITION}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUnits = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_UNITS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductRef = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_PRODUCT_REF}`, {
      params: id,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_SUPPLIER}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserSuppliers = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_USER_SUPPLIERS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomType = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_BOM_TYPE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomComponent = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_BOM_COMPONENT}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addSupplierSuggestion = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.ADD_SUPPLIER_SUGGESTION}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierSuggestionList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.SUPPLIER_SUGGESTION_LIST}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierSuggestionDetail = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.SUPPLIER_SUGGESTION_DETAIL}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSuggestion = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.SUPPLIER_SUGGESTION_DELETE}`, { params: id });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// testing suggestion service methods

export const getBomComponentRefCodes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_BOM_COMPONENT}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColourWays = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_COLOUR_WAYS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const approveSuggestion = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.APPROVE_SUGGESTION}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getTestingLibraries = async (devOrderId, isToFilterSuggestion) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_TESTING_LIBRARIES}/${devOrderId}`, { params: { isToFilterSuggestion } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const rejectSuggestion = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.REJECT_SUGGESTION}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getTestingLibraryById = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_TESTING_LIBRARY_BYID}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurementById = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_ORDER_MEASURENT}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurementPermissionByID = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_MEASUREMENT_PERMISSON}`, {
      params: devOrderId,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getHideShowGradingByID = async (devOrderId, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_GRADING}/${devOrderId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadImage = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING_SUGGESTION.SUGGESTION_UPLOAD_IMG}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const unlinkImage = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING_SUGGESTION.SUGGESTION_UNLINK_IMG}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelPermissionByID = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_CARELABEL_PERMISSON}`, {
      params: devOrderId,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelById = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING_SUGGESTION.GET_CARE_LABEL}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSeasons = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_SEASONS}`, {
      params: id,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSupplierSuggestion = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.UPDATE_SUPPLIER_SUGGESTION}`, data, {
      params: { suggestionId: data.suggestionId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
